import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Footer from '../components/footer';

import '../../sass/style.scss';

const title = 'MajorKey';
const appUrl = 'https://majorkey.app';
const description = 'Get the most out of your keyboard.';
const thumbnail = '/images/ok-emoji.png ';
const featuredImage = appUrl + '/images/majorkey-social-card.png ';
const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title={title}
      link={[{
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css?family=Rubik:300,400,500,700'
      },{
        rel: 'icon',
        href: thumbnail
      }]}
      meta={[{
        name: 'description',
        content: description
      }, {
          property: 'og:title',
          content: title
        }, {
          property: 'og:description',
          content: description
        }, {
          property: 'og:image',
          content: featuredImage
        }, {
          property: 'og:url',
          content: appUrl
        }, {
          property: 'twitter:title',
          content: title
        }, {
          property: 'twitter:description',
          content: description
        }, {
          property: 'twitter:image',
          content: thumbnail
        }, {
          property: 'twitter:card',
          content: featuredImage
        }]}>
      <script src="https://embed.small.chat/T629YTBEDG644CQPF1.js" async></script>
    </Helmet>    
    {children()}
    <Footer />
    
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js